<template>
  <div>
    <h3 class="text-center">{{title}}</h3>
    <div :id="(uniqueName ? uniqueName : divName)"></div>
  </div>
</template>
<script>
// Eslint disable for the 'for in' statement
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */

import CalHeatMap from 'cal-heatmap';
import moment from 'moment';

export default {
  props: ['data', 'uniqueName', 'title'],
  data() {
    return {
      calendarData: {},
      calendar: null,
      divName: 'default-cal',
    };
  },
  computed: {
    // Ensuring that the range is updated every year by one
    numOfYears() {
      const currentDate = moment(new Date());
      const startingDate = moment(new Date(2014, 0));

      // rounding up the number to include 2014 in the count
      const range = Math.ceil(currentDate.diff(startingDate, 'years', true));

      return range;
    },
  },
  mounted() {
    const cal = new CalHeatMap();

    if (this.data) {
      this.calendarData = this.data;
    }

    if (this.uniqueName) {
      cal.init({
        itemSelector: `#${this.uniqueName ? this.uniqueName : this.divName}`,
        domain: 'year',
        domainMargin: 8,
        subDomain: 'x_day',
        rowLimit: 30,
        tooltip: true,
        verticalOrientation: true,
        data: this.calendarData,
        start: new Date(2014, 0),
        cellSize: 12,
        range: this.numOfYears,
        legendCellPadding: 5,
        legend: [0, 5],
        legendCellSize: 15,
        legendVerticalPosition: 'center',
        legendOrientation: 'vertical',
        legendMargin: [0, 25, 0, 0],
        label: {
          position: 'bottom',
          align: 'center',
          width: 40,
        },
        itemName: ['data point', 'data points'],
        // subDomainTextFormat: "%d",
        subDomainTitleFormat: {
          empty: 'Data not found on {date}',
          filled: '{count} {name} available on {date}',
        },
        afterLoadData(data) {
          const offset = new Date().getTimezoneOffset() * 60;
          const results = {}; // holder for the new parsed data

          for (let timestamp in data) {
            const commitCount = data[timestamp];
            timestamp = parseInt(timestamp, 10);
            results[timestamp + offset] = commitCount;
          }
          return results;
        },
      });
    }
  },
};
</script>

<style>
.q0 {
  background-color: #c4c4c4 !important;
  fill: #c4c4c4 !important;
}
.q3 {
  background-color: #3b6428 !important;
  fill: #3b6428 !important;
}
.cal-heatmap-container .graph-label  {
  font-size: 15px;
  font-weight: bold;
  fill: black;
}

/** This is used for the border color of the hovered box */
.cal-heatmap-container .graph-subdomain-group rect:hover
{
  stroke: #64283B;
  stroke-width: 2px
}

/** This is for the hover tooltip to not have a pointer on the box since it is offsets */
.ch-tooltip::after{
  position: relative;
  display: block;
}
</style>
